export const translations = {
	'Message center': {
		no: 'Meldingssenter',
	},
	'custom': {
		no: 'Tilpasset',
	},
	'create': {
		no: 'opprett',
	},
	'cancel': {
		no: 'avbryt',
	},
	'update': {
		no: 'oppdater',
	},
	'name': {
		no: 'navn',
	},
	'type': {
		no: 'type',
	},
	'value': {
		no: 'verdi',
	},
	'selector': {
		no: 'selektor',
	},
	'select': {
		no: 'velg',
	},
	'select...': {
		no: 'velg...',
	},
	'description': {
		no: 'beskrivelse',
	},
	'search': {
		no: 'søk',
	},
	'search...': {
		no: 'søk...',
	},
	'get': {
		no: 'hent',
	},
	'minimize': {
		no: 'minimere',
	},
	'maximize': {
		no: 'maksimere',
	},
	'default': {
		no: 'standard',
	},
	'next': {
		no: 'neste',
	},
	'previous': {
		no: 'forrige',
	},
	'create new': {
		no: 'opprett ny',
	},
	'favorites': {
		no: 'favoritter',
	},
	'delete': {
		no: 'slett',
	},
	'operator': {
		no: 'operator',
	},
	'from': {
		no: 'fra',
	},
	'to': {
		no: 'til',
	},
	'severity': {
		no: 'alvorlighetsgrad',
	},
	'authenticate': {
		no: 'autentiser',
	},
	'authenticating': {
		no: 'autentiserer',
	},
	'authentication': {
		no: 'autentisering',
	},
	'Asset Target': {
		no: 'ressursmål',
	},
	'Asset Group': {
		no: 'ressursgruppe',
		en: 'Assetgroup',
	},
	'Asset Groups': {
		no: 'ressursgruppe',
		en: 'Assetgroups',
	},
	'url': {
		no: 'url',
	},
	'port': {
		no: 'port',
	},
	'uptime': {
		no: 'oppetid',
	},
	'source': {
		no: 'kilde',
	},
	'reload': {
		no: 'last på nytt',
	},
	'configuration': {
		no: 'konfigurasjon',
	},
	'profile': {
		no: 'profil',
	},
	'clear results': {
		no: 'fjern resultater',
	},
	'there is no data available': {
		no: 'ingen data tilgjengelig',
	},
	'Service Element': {
		no: 'tjenesteelement',
		en: 'Service element',
	},
	'Service Qualifier': {
		no: 'tjenestepunkt',
		en: 'Servicequalifier',
	},
	'application': {
		no: 'applikasjon',
	},
	'Dirty check confirmation': {
		no: 'Du har ulagret innhold. Du vil miste endringen hvis du klikker Lukk. Trykk avbryt og lagre endringen hvis du vil beholde dem.',
		en: 'You have unsaved content. You will lose the changes if you click Close. Click Cancel and save the changes if you want to keep them.',
	},
	'Service Model': {
		no: 'Tjenestemodell',
		en: 'Servicemodel',
	},
	'database': {
		no: 'database',
	},
	'driver': {
		no: 'driver',
	},
	'Connection String': {
		no: 'tilkoblingstreng',
		en: 'Connection string',
	},
	'generic': {
		no: 'generisk',
	},
	'general': {
		no: 'generell',
	},
	'monitor general': {
		no: 'standard',
		en: 'general',
	},
	'Monitor Settings': {
		no: 'Monitorinstillinger',
		en: 'Monitor settings',
	},
	'reason message': {
		no: 'årsaksmelding',
	},
	'Authentication Type': {
		no: 'autentiseringstype',
		en: 'Authentication type',
	},
	'select service': {
		no: 'Velg tjeneste',
	},
	'exclude': {
		no: 'Eksluder',
	},
	'padding': {
		no: 'padding',
	},
	'dashboard': {
		no: 'dashboard',
	},
	'dashboards': {
		no: 'dashboards',
	},
	'authentications': {
		no: 'autentisering',
	},
	'calendar': {
		no: 'kalender',
	},
	'roles': {
		no: 'roller',
	},
	'templates': {
		no: 'maler',
	},
	'team': {
		no: 'gruppe',
	},
	'teams': {
		no: 'grupper',
	},
	'user': {
		no: 'Bruker',
	},
	'users': {
		no: 'Brukere',
	},
	'asset': {
		no: 'ressurs',
	},
	'assets': {
		no: 'ressurser',
	},
	'Health Reason': {
		no: 'helseårsak',
		en: 'Health reason',
	},
	'Health Reasons': {
		no: 'helseårsaker',
		en: 'Health reasons',
	},
	'monitor': {
		no: 'monitor',
	},
	'monitors': {
		no: 'monitorer',
	},
	'filter': {
		no: 'filter',
	},
	'filters': {
		no: 'filtre',
	},
	'management': {
		no: 'system',
	},
	'accounts': {
		no: 'kontoer',
	},
	'account': {
		no: 'konto',
	},
	'agent': {
		no: 'agent',
	},
	'agents': {
		no: 'agenter',
	},
	'integration': {
		no: 'integrasjon',
	},
	'repository': {
		no: 'pakkearkiv',
	},
	'modules': {
		no: 'komponenter',
	},
	'audit': {
		no: 'revisjon',
	},
	'Active Users': {
		no: 'aktive brukere',
		en: 'Active users',
	},
	'system messages': {
		no: 'systemmeldinger',
	},
	'home': {
		no: 'hjem',
	},
	'infrastructure': {
		no: 'infrastruktur',
	},
	'about': {
		no: 'om',
	},
	'advanced': {
		no: 'avansert',
	},
	'enabled': {
		no: 'Aktiv',
	},
	'scale': {
		no: 'skaler',
	},
	'data is not available': {
		no: 'data is not available',
	},
	'loading...': {
		no: 'laster...',
	},
	'top': {
		no: 'topp',
	},
	'bottom': {
		no: 'bottom',
	},
	'none': {
		no: 'Ingen',
	},
	'position': {
		no: 'ingen',
	},
	'Include subaccounts': {
		no: 'Inkluder underkontoer',
	},
	'Show Untagged': {
		no: 'Vis uten etikett',
		en: 'Show untagged',
	},
	'Select Team': {
		no: 'Velg team',
		en: 'Select team',
	},
	'no data': {
		no: 'ingen data',
	},
	'Measuring Agent': {
		no: 'måleagent',
		en: 'Measuring agent',
	},
	'Measuring Target': {
		no: 'Mål',
		en: 'Measuring target',
	},
	'please fill in the field': {
		no: 'fyll inn feltet',
	},
	'The input value should be between {0} and {1}': {
		no: 'Sett inn en verdi mellom {0} og {1}',
	},
	'Template Asset': {
		no: 'ressursmal',
		en: 'Template asset',
	},
	'Warning threshold': {
		no: 'advarsel terskel',
	},
	'Critical threshold': {
		no: 'kritisk terskel',
	},
	'Warning severity': {
		no: 'Advarsel alvorlighet',
	},
	'Critical severity': {
		no: 'Kritisk alvorlighet',
	},
	'threshold': {
		no: 'terskelverdi',
	},
	'new monitor': {
		no: 'ny monitor',
	},
	'click to edit': {
		no: 'Klikk for å redigere',
	},
	'interface traffic': {
		no: 'interface traffic',
	},
	'trend': {
		no: 'trend',
	},
	'timeout (sec)': {
		no: 'tidsavbrudd (sek)',
	},
	'disable': {
		no: 'deaktiver',
	},
	'enable': {
		no: 'aktiver',
	},
	'Monitor Error': {
		no: 'monitorfeil',
		en: 'Monitor error',
	},
	'Please input Name...': {
		no: 'Skriv inn navn...',
		en: 'Please input name...',
	},
	'cost': {
		no: 'kost',
	},
	'Unexpected server error': {
		no: 'Uventet server feil',
	},
	'Not available': {
		no: 'Ikke tilgjengelig',
	},
	'Set in Maintenance': {
		no: 'Sett i vedlikehold',
		en: 'Set in maintenance',
	},
	'End Maintenance': {
		no: 'Avslutt vedlikehold',
		en: 'End maintenance',
	},
	'Set Tags': {
		no: 'Sett etikett',
		en: 'Set tag',
	},
	'Agent Name': {
		no: 'Agentnavn',
		en: 'Agent name',
	},
	'Measuring Asset': {
		no: 'Måle ressurs',
		en: 'Measuring asset',
	},
	'Asset Name': {
		no: 'Ressursnavn',
		en: 'Asset name',
	},
	'Monitor name': {
		no: 'Monitornavn',
	},
	'Monitor Type': {
		no: 'Monitortype',
		en: 'Monitor type',
	},
	'Target name': {
		no: 'Målnavn',
	},
	'Target type': {
		no: 'Måltype',
	},
	'Measuring Type': {
		no: 'Måletype',
		en: 'Measuring type',
	},
	'Select Asset Group...': {
		no: 'Velg ressursgruppe...',
		en: 'Select assetgroup...',
	},
	'Select Asset...': {
		no: 'Velg ressurs...',
		en: 'Select asset...',
	},
	'Event State': {
		no: 'Hendelse',
		en: 'Event',
	},
	'Content is filtered': {
		no: 'Innholdet er filtrert',
	},
	'Agent ID': {
		no: 'Agent ID',
	},
	'External ID': {
		no: 'Ekstern ID',
	},
	'External Owner': {
		no: 'Ekstern eier',
		en: 'External owner',
	},
	'Identifier Name': {
		no: 'Identifikator navn',
		en: 'Identifier name',
	},
	'subsystem': {
		no: 'Subsystem',
	},
	'Identifier Instance': {
		no: 'Identifikator instans',
		en: 'Identifier instance',
	},
	'Monitor Class': {
		no: 'Monitorklasse',
		en: 'Monitor class',
	},
	'Source ID': {
		no: 'Source ID',
	},
	'Target ID': {
		no: 'Target ID',
	},
	'Time Deleted': {
		no: 'Tid slettet',
		en: 'Time deleted',
	},
	'time': {
		no: 'Tid',
	},
	'date': {
		no: 'Dato',
	},
	'message': {
		no: 'Melding',
		en: 'Message',
	},
	'suppression': {
		no: 'Undertrykk',
	},
	'Acknowledged at': {
		no: 'Bekreftet tid',
	},
	'Acknowledged by': {
		no: 'Bekreftet av',
	},
	'Assigned by': {
		no: 'Tildelt av',
	},
	'acknowledged': {
		no: 'Bekreftet',
	},
	'acknowledge': {
		no: 'Bekreft',
	},
	'unacknowedge': {
		no: 'Ubekreft',
	},
	'Action Count': {
		no: 'Handlingsantall',
		en: 'Action count',
	},
	'In Maintenance': {
		no: 'Vedlikehold',
		en: 'In maintenance',
	},
	'Assigned Type': {
		no: 'Tildelt type',
		en: 'Assigned type',
	},
	'Assigned To': {
		no: 'Tildelt til',
		en: 'Assigned to',
	},
	'Assigned Time': {
		no: 'Tildelt tid',
		en: 'Assigned time',
	},
	'assign': {
		no: 'Tildele',
		en: 'Assign',
	},
	'unassign': {
		no: 'Fjern tildeling',
	},
	'New Monitor': {
		no: 'Ny monitor',
		en: 'New monitor',
	},
	'Asset target is in use': {
		no: 'Ressursmålet er i bruk',
	},
	'Please add targets to your asset': {
		no: 'Legg til mål for din ressurs',
	},
	'Select an Asset Group...': {
		no: 'Velg ressursgruppe...',
		en: 'Select assetgroup...',
	},
	'Select a Service...': {
		no: 'Velg en tjeneste...',
		en: 'Select service...',
	},
	'Select a Service Element...': {
		no: 'Velg tjenesteelement...',
		en: 'Select service element...',
	},
	'Select a Service Qualifier...': {
		no: 'Velg et tjenestepunkt',
		en: 'Select servicequalifier...',
	},
	'Select an Asset...': {
		no: 'Velg ressurs...',
		en: 'Select asset...',
	},
	'decimals': {
		no: 'Desimal',
	},
	'Cost Store': {
		no: 'Kostnad Base',
		en: 'Cost store',
	},
	'budget': {
		no: 'Budsjett',
	},
	'expand': {
		no: 'Ekspander',
	},
	'Cost Sheet': {
		no: 'Kost ark',
		en: 'Cost sheet',
	},
	'Cost Type': {
		no: 'Kost type',
		en: 'Cost type',
	},
	'Time Range': {
		no: 'Tidsramme',
		en: 'Time range',
	},
	'currency': {
		no: 'Valuta',
	},
	'estimate': {
		no: 'Estimate',
	},
	'Select All': {
		no: 'Velg alle',
		en: 'Select all',
	},
	'Deselect All': {
		no: 'Fjern valgte',
		en: 'deselect all',
	},
	'interval': {
		no: 'Intervall',
	},
	'schedule': {
		no: 'Tidsplan',
	},
	'collapse': {
		no: 'Kollaps',
	},
	'Select Severity': {
		no: 'Velg alvorlighet',
		en: 'Select severity',
	},
	'activate': {
		no: 'aktiver',
	},
	'deactivate': {
		no: 'inaktiver',
	},
	'Profile Name': {
		no: 'Profilnavn',
		en: 'Profile name',
	},
	'Edit Profile Name': {
		no: 'Rediger profilnavn',
		en: 'Edit profile name',
	},
	'Delete Profile': {
		no: 'Slett profil',
		en: 'Delete profile',
	},
	'Alert Message': {
		no: 'Varselmelding',
		en: 'Alert message',
	},
	'Default Configuration': {
		no: 'Standard konfigurasjon',
		en: 'Default donfiguration',
	},
	'Process Name': {
		no: 'Prosess navn',
		en: 'Process name',
	},
	'Command Line': {
		no: 'Kommandolinje',
		en: 'Command line',
	},
	'Process State': {
		no: 'Prosesstilstand',
		en: 'Process state',
	},
	'profiles': {
		no: 'Profiler',
	},
	'n/a': {
		no: 'N/A',
		en: 'N/A',
	},
	'menu': {
		no: 'Meny',
	},
	'Refresh Timer': {
		no: 'Oppdateringstid',
		en: 'Refresh time',
	},
	'timebar': {
		no: 'Tidsvelger',
	},
	'Required field': {
		no: 'Påkrevd felt',
	},
	'Time settings': {
		no: 'Tidsinnstillinger',
	},
	'Time Zone': {
		no: 'Tidssone',
		en: 'Time zone',
	},
	'Name exists': {
		no: 'Et identisk navn finnes på denne kontoen, bruk et annet navn.',
		en: 'An identical name exist on this account, please use another name.',
	},
	'Agent in warning': {
		no: 'Agent har advarsel',
	},
	'Agent is down': {
		no: 'Agenten er nede',
	},
	'Qualifier error': {
		no: 'Tjenestepunkt feil',
	},
	'Asset in maintenance': {
		no: 'Ressursen er satt i vedlikehold',
	},
	'Agent in maintenance': {
		no: 'Agent er i vedlikehold',
	},
	'Service in maintenance': {
		no: 'Tjenesten er i vedlikehold',
	},
	'Monitor in maintenance': {
		no: 'Monitor in vedlikehold',
	},
	'Monitor error': {
		no: 'Monitorfeil',
	},
	'Outside operating period': {
		no: 'Utenfor driftstid',
	},
	'Monitor error: data unavailable': {
		no: 'Monitorfeil: Data er ikke tilgjengelig',
		en: 'Monitor error: Data unavailable',
	},
	'Account name': {
		no: 'Kontonavn',
	},
	'Unit type': {
		no: 'Enhetstype',
	},
	'Metric type': {
		no: 'Metrikktype',
	},
	'Registry identifier': {
		no: 'Register id',
	},
	'Registry type': {
		no: 'Registertype',
	},
	'Registry owner id': {
		no: 'Registereier id',
	},
	'Metric id': {
		no: 'Metrikk id',
	},
	'Data registry': {
		no: 'Data register',
	},
	'Max value': {
		no: 'Maks verdi',
	},
	'metrics': {
		no: 'metrikker',
	},
	'instance': {
		no: 'instans',
	},
	'datasource': {
		no: 'datakilde',
	},
	'Event summary': {
		no: 'Hendelse oversikt',
	},
	'Display settings': {
		no: 'Skjerminnstillinger',
	},
	'presentation': {
		no: 'Presentasjon',
	},
	'Time selector': {
		no: 'Tidsvelger',
	},
	'active': {
		no: 'Aktiv',
	},
	'inactive': {
		no: 'Inaktiv',
		en: 'Inactive',
	},
	'subscription': {
		no: 'abonnement',
	},
	'subscriptions': {
		no: 'abonnement',
	},
	'There was an error while loading data': {
		no: 'Det oppstod en feil ved lasting av data',
		en: 'There was an error loading data',
	},
	'Reset to default': {
		no: 'Tilbakestill til standard',
		en: 'Reset to default',
	},
	'Service name': {
		no: 'Tjenestenavn',
	},
	'Data not found': {},
	'complete': {
		no: 'Komplett',
	},
	'Value type': {
		no: 'Verditype',
	},
	'priority': {
		no: 'Prioritet',
	},
	'modified': {
		no: 'Endret',
	},
	'Export to CSV': {
		no: 'Eksporter til CSV',
	},
	'Min value': {
		no: 'Min verdi',
	},
	'Identical name exists validation message': {
		no: 'Et identisk navn finnes på denne kontoen, bruk et annet navn.',
		en: 'An identical name exist on this account, please use another name.',
	},
	'autoscaling': {
		no: 'autoskalering',
	},
	'placeholder': {
		no: 'plassholder',
	},
	'row': {
		no: 'rad',
	},
	'required': {
		no: 'påkrevd',
		en: 'required',
	},
	'breached': {
		no: 'Brudd',
	},
	'warning': {
		no: 'Advarsel',
	},
	'compliant': {
		no: 'Samsvar',
	},
	'out of': {
		no: 'av',
	},
	'info': {
		no: 'Info',
	},
	'group': {
		no: 'Gruppe',
	},
	'key': {
		no: 'Nøkkel',
	},
	'field': {
		no: 'Felt',
	},
	'ok': {
		no: 'OK',
		en: 'OK',
	},
	'critical': {
		no: 'Kritisk',
		en: 'Critical',
	},
	'major': {
		no: 'Alvorlig',
		en: 'Major',
	},
	'minor': {
		no: 'Varsel',
		en: 'Minor',
	},
	'category': {
		no: 'Kategori',
	},
	'persist': {
		no: 'Vedvare',
	},
	'apply': {
		no: 'Bruk',
	},
	'alert': {
		no: 'Advarsel',
	},
	'Set tags': {
		no: 'Sett etikett',
	},
	'clear': {
		no: 'Tøm',
	},
	'error': {
		no: 'Feil',
	},
	'week': {
		no: 'Uke',
	},
	'maintenance': {
		no: 'Vedlikehold',
	},
	'yes': {
		no: 'Ja',
	},
	'no': {
		no: 'Nei',
	},
	'add': {
		no: 'Legg til',
	},
	'target': {
		no: 'Mål',
	},
	'monday': {
		no: 'Mandag',
	},
	'tuesday': {
		no: 'Tirsdag',
	},
	'wednesday': {
		no: 'Onsdag',
	},
	'thursday': {
		no: 'Torsdag',
	},
	'friday': {
		no: 'Fredag',
	},
	'saturday': {
		no: 'Lørdag',
	},
	'sunday': {
		no: 'Søndag',
	},
	'businessweek': {
		no: 'Arbeidsuke',
	},
	'weekend': {
		no: 'Helg',
	},
	'event': {
		no: 'Hendelse',
	},
	'Health reasons': {
		no: 'Helseårsaker',
	},
	'Health reason': {
		no: 'Helseårsak',
	},
	'SQ metrics': {
		no: 'Tjenestepunkt metrikker',
	},
	'Monitor metrics': {
		no: 'Monitor metrikker',
	},
	'External metrics': {
		no: 'Eksterne metrikker ',
	},
	'unacknowledge': {
		no: 'Ubekreft',
	},
	'Set Information': {
		no: 'Sett informasjon',
	},
	'Media library': {
		no: 'Media bibliotek',
	},
	'entries': {
		no: 'Oppføringer',
	},
	'Delete healthreason': {
		no: 'Slett helseårsak',
	},
	'Assigned type': {
		no: 'Tildelt type',
	},
	'state': {
		no: 'Tilstand',
	},
	'service': {
		no: 'Tjeneste',
		en: 'Service',
	},
	'classname': {
		no: 'Klassenavn',
	},
	'responsible': {
		no: 'Ansvarlig',
	},
	'up': {
		no: 'Oppe',
	},
	'down': {
		no: 'Nede',
	},
	'vendor': {
		no: 'Leverandør',
	},
	'version': {
		no: 'Versjon',
	},
	'Install date': {
		no: 'Installasjonsdato',
	},
	'Register time': {
		no: 'Registrert tid',
	},
	'action': {
		no: 'Handling',
	},
	'Select action': {
		no: 'Velg hendelse',
	},
	'Assign event': {
		no: 'Tildel hendelse',
	},
	'Merge assets': {
		no: 'Kombiner ressurser',
	},
	'Set in maintenance': {
		no: 'Sett i vedlikehold',
	},
	'End maintenance': {
		no: 'Avslutt vedlikehold',
	},
	'unavailable': {
		no: 'Ikke tilgjengelig',
	},
	'assetgroups': {
		no: 'Ressursgrupper',
	},
	'status': {
		no: 'Status',
	},
	'account/subaccount': {
		no: 'Konto og underkonto',
	},
	'subaccount': {
		no: 'Underkontoer',
	},
	'all': {
		no: 'Alle',
	},
	'Day selection': {
		no: 'Dag valg',
	},
	'filtered': {
		no: 'Filtrert',
	},
	'created': {
		no: 'Opprettet',
	},
	'Account selection': {
		no: 'Kontovalg',
	},
	'test': {
		no: 'Test',
	},
	'pattern': {
		no: 'Mønster',
	},
	'separator': {
		no: 'Skilletegn',
	},
	'true': {
		no: 'Sann',
	},
	'false': {
		no: 'Usann',
	},
	'Greater or equal than': {
		no: 'Større eller lik',
	},
	'Less or equal than': {
		no: 'Mindre eller lik',
	},
	'caption': {
		no: 'Caption',
	},
	'process': {
		no: 'Prosess',
	},
	'missing': {
		no: 'Mangler',
	},
	'original': {
		no: 'Opprinnelig',
	},
	'excluded': {
		no: 'Untatt',
	},
	'running': {
		no: 'Kjører',
	},
	'stopped': {
		no: 'Stoppet',
	},
	'actions': {
		no: 'Handlinger',
	},
	'save': {
		no: 'Lagre',
	},
	'auto': {
		no: 'AUTO',
		en: 'AUTO',
	},
	'memory': {
		no: 'Minne',
	},
	'disk': {
		no: 'Disk',
	},
	'used': {
		no: 'Brukt',
	},
	'total': {
		no: 'Total',
	},
	'title': {
		no: 'Tittel',
	},
	'gauge': {
		no: 'Måler',
	},
	'Solid gauge': {
		no: 'Solid måler',
	},
	'filtering': {
		no: 'Filtrering',
	},
	'Show untagged': {
		no: 'Vis uten etikett',
	},
	'Single graph': {
		no: 'Graf',
	},
	'reset': {
		no: 'Tilbakestill',
	},
	'Aggregation type': {
		no: 'Aggregeringstype',
	},
	'Area spline': {
		no: 'Areaspline',
	},
	'Spline chart': {
		no: 'Spline graf',
	},
	'selection': {
		no: 'Seleksjon',
	},
	'multigraph': {
		no: 'Multigraf',
	},
	'selected': {
		no: 'Valgt',
	},
	'Choose logo image': {
		no: 'Velg logo bilde',
	},
	'card': {
		no: 'Kort',
	},
	'cvid': {
		no: 'CVID',
		en: 'CVID',
	},
	'This will merge all the selected assets into this asset: ASSETNAME. Click update to continue the merge or cancel to return to the merge asset form.':
		{
			no: 'Dette vil kombinere valgte ressursene til ressurs: ASSETNAME. Klikk oppdater for å fortsette eller avbryt for å returnere til meny.',
		},
	'password': {
		no: 'Passord',
	},
	'username': {
		no: 'Brukernavn',
	},
	'today': {
		no: 'I dag',
	},
	'month': {
		no: 'Måned',
	},
	'day': {
		no: 'Dag',
	},
	'list': {
		no: 'Liste',
	},
	'healthindex': {
		no: 'Helseindeks',
	},
	'module': {
		no: 'Modul',
	},
	'read': {
		no: 'Les',
	},
	'write': {
		no: 'Skriv',
	},
	'details': {
		no: 'Detaljer',
	},
	'Select users': {
		no: 'Velg brukere',
	},
	'Filter type': {
		no: 'Filtertype',
	},
	'Add notification': {
		no: 'Legg til varsel ',
	},
	'Disable notification': {
		no: 'Deaktiver varsel',
	},
	'Delete notification': {
		no: 'Slett varsel',
	},
	'channels': {
		no: 'Kanal',
	},
	'notification': {
		no: 'Varsel',
	},
	'Enable notification': {
		no: 'Aktiver varsling',
	},
	'Action trigger': {
		no: 'Handlingsutløser',
	},
	'import': {
		no: 'Importer ',
	},
	'export': {
		no: 'Eksporter',
	},
	'First name': {
		no: 'Fornavn',
	},
	'Last name': {
		no: 'Etternavn',
	},
	'email': {
		no: 'Epost',
	},
	'Add event actiontrigger': {
		no: 'Hendelsetrigger',
	},
	'Add health actiontrigger': {
		no: 'Helsetrigger',
	},
	'role': {
		no: 'Rolle',
	},
	'unit': {
		no: 'Enhet',
	},
	'Custom unit': {
		no: 'Tilpasset enhet',
	},
	'conversion': {
		no: 'Konvertering',
	},
	'color': {
		no: 'Farge',
	},
	'informational': {
		no: 'Informasjon',
	},
	'Collapse all': {
		no: 'Lukk alle',
	},
	'failed': {
		no: 'Feilet',
	},
	'image': {
		no: 'Bilde',
	},
	'back': {
		no: 'Tilbake',
	},
	'Healthreason text': {
		no: 'Helseårsaktekst',
	},
	'text': {
		no: 'Tekst',
	},
	'shared': {
		no: 'Delt',
	},
	'public': {
		no: 'Åpen',
	},
	'private': {
		no: 'Privat',
	},
	'aggregated': {
		no: 'Aggregert',
	},
	'Select service...': {
		no: 'Velg tjeneste...',
	},
	'Asset target': {
		no: 'Ressursmål',
	},
	'edit': {
		no: 'Endre',
	},
	'file': {
		no: 'Fil',
		en: 'File',
	},
	'tag': {
		no: 'Etikett',
	},
	'paste': {
		no: 'Lim inn',
	},
	'servicelink': {
		no: 'Tjenestelink',
	},
	'copy': {
		no: 'Kopier',
	},
	'share': {
		no: 'Del',
	},
	'convert': {
		no: 'Konverter',
	},
	'equal': {
		no: 'Lik',
	},
	'Greater than': {
		no: 'Større enn',
	},
	'Less than': {
		no: 'Mindre enn',
	},
	'Not equal': {
		no: 'Ikke lik',
	},
	'min': {
		no: 'Min',
	},
	'max': {
		no: 'Maks',
	},
	'percentile': {
		no: 'Persentil',
	},
	'days': {
		no: 'Dager',
	},
	'and': {
		no: 'Og',
		en: 'And',
	},
	'or': {
		no: 'Eller',
		en: 'Or',
	},
	'not': {
		no: 'Ikke',
	},
	'finish': {
		no: 'Fullført',
	},
	'icons': {
		no: 'ikoner',
	},
	'show': {
		no: 'Vis',
	},
	'hide': {
		no: 'Skjul',
	},
	'download': {
		no: 'Last ned',
	},
	'Service is UP': {
		no: 'Tjenesten er OPPE',
	},
	'preview': {
		no: 'Forhåndsvisning',
	},
	'recalculate': {
		no: 'Rekalkuler',
	},
	'Service is DOWN': {
		no: 'Tjenesten er NEDE',
	},
	'Service is INACTIVE': {
		no: 'Tjenesten er inaktiv',
	},
	'Add url': {
		no: 'Legg til Url',
	},
	'Recalculate service SLA': {
		no: 'Rekalkuler tjeneste SLA',
	},
	'recalculation': {
		no: 'Rekalkulering',
	},
	'Error message': {
		no: 'Feilmelding',
	},
	'Servicelog message': {
		no: 'Melding i tjenestelogg',
	},
	'unknown': {
		no: 'Ukjent',
	},
	'minute': {
		no: 'Minutt',
	},
	'In order to see other rootcauses please use a smaller timeselection or zoom to the given time': {
		no: 'For å se andre rothelseårsaker bruk en kortere tidsperiode eller zoom til ønsket tid.',
	},
	'Service breaches': {
		no: 'Tjenestebrudd',
	},
	'Service downtime': {
		no: 'Nedetid tjeneste',
	},
	'State duration': {
		no: 'Tilstandsvarighet',
	},
	'allocated': {
		no: 'Allokert',
	},
	'Table name': {
		no: 'Tabellnavn',
	},
	'rows': {
		no: 'Størrelse',
	},
	'server': {
		no: 'Server',
	},
	'Download logview': {
		no: 'Last ned aktiv logg',
	},
	'Download log folder': {
		no: 'Last ned loggmappe',
	},
	'Restore default': {
		no: 'Gjenopprett standard',
	},
	'topic': {
		no: 'Emne',
	},
	'data': {
		no: 'Data',
	},
	'in': {
		no: 'Inn',
	},
	'out': {
		no: 'Ut',
	},
	'Parent agent': {
		no: 'Eies av agent',
	},
	'Server version': {
		no: 'Server versjon',
	},
	'operation': {
		no: 'Handling',
	},
	'installed': {
		no: 'Installert',
	},
	'Not installed': {
		no: 'Ikke installert',
	},
	'Full name': {
		no: 'Fullt navn',
	},
	'Session Id': {
		no: 'Sesjonsid',
	},
	'logout': {
		no: 'Logg ut',
	},
	'kpi': {
		no: 'KPI',
		en: 'KPI',
	},
	'percentage': {
		no: 'Prosentandel',
	},
	'compliance': {
		no: 'Samsvar',
	},
	'downtime': {
		no: 'Nedetid',
	},
	'ms': {
		no: 'ms',
	},
	'revert': {
		no: 'Tilbakestill',
	},
	'planning': {
		no: 'Planlegging',
		en: 'Planning',
	},
	'holiday': {
		no: 'Helligdag',
		en: 'Holiday',
	},
	'Created time': {
		no: 'Opprettet tid',
	},
	'visbility': {
		no: 'Synlighet',
	},
	'Achieved percentage': {
		no: 'Oppnådd prosent',
	},
	'Breached percentage': {
		no: 'Brutt prosent',
	},
	'severities': {
		no: 'Alvorlighet',
	},
	'Action type': {
		no: 'Handlingstype',
	},
	'Action data': {
		no: 'Handlingsdata',
	},
	'notificationtrigger': {
		no: 'Varslingstrigger',
	},
	'Mark as read': {
		no: 'Merk som lest',
	},
	'comments': {
		no: 'Kommentarer',
	},
	'Please input a valid email address': {
		no: 'Skriv en gyldig epost addresse',
	},
	'The configuration is valid.': {
		no: 'Konfigurasjon er gyldig',
	},
	'Select application...': {
		no: 'Velg applikasjon...',
	},
	'Select Assetgroup...': {
		no: 'Velg ressursgruppe...',
	},
	'Select SLA...': {
		no: 'Velg SLA...',
	},
	'language': {
		no: 'Språk',
	},
	'quarter': {
		no: 'Kvartal',
	},
	'generate': {
		no: 'Generer',
	},
	'comment': {
		no: 'Kommentar',
	},
	'subgroup': {
		no: 'Subgruppe',
	},
	'Test ruleset': {
		no: 'Test regelsett',
	},
	'Click to edit assetgroup': {
		no: 'Klikk for å redigere ressursgruppen',
	},
	'Old password': {
		no: 'Gammelt passord',
	},
	'Confirm password': {
		no: 'Bekreft passord',
	},
	'Last changes': {
		no: 'Siste endringer',
	},
	'User profile': {
		no: 'Brukerprofil',
	},
	'User Profile': {
		no: 'Brukerprofil',
	},
	'Please set a strong password.': {
		no: 'Du må endre passordet. ',
	},
	'The password must not contain blank spaces': {
		no: 'Passord kan ikke inneholde tomme felter',
	},
	'Create calendar': {
		no: 'Opprett kalender',
	},
	'Currently, you have no unread messages': {
		no: 'Du har ingen uleste meldinger.',
	},
	'Go to message center': {
		no: 'Gå til meldingsenter',
	},
	'There might be a problem with your internet connection. Credentials not sent': {
		no: 'Det kan være et problemt med nettverket. Brukerinformasjon er ikke sendt',
	},
	'User settings have been successfully cleared': {
		no: 'Bruker instilling ble nullstilt for gjeldende side',
	},
	'This will be your first account, set a name for it.': {
		no: 'Sett navn for konto',
	},
	'Please, input a team name': {
		no: 'Sett inn navn på team',
	},
	'The username must not contain blank spaces': {
		no: 'Brukernavn kan ikke inneholde tomme felter',
	},
	'The password should contain min 8 characters and numbers': {
		no: 'Passordet må inneholde minst 8 bokstaver og tall',
	},
	'remove': {
		no: 'Fjern',
	},
	'parent': {
		no: 'Tilhører',
	},
	'id': {
		no: 'Id',
		en: 'ID',
	},
	'Show advanced information': {
		no: 'Vis avansert informasjon',
	},
	'Advanced information': {
		no: 'Avansert informasjon',
	},
	'Hide advanced information': {
		no: 'Skjul avansert informasjon',
	},
	'Pause events': {
		no: 'Pause hendelser',
	},
	'Play events': {
		no: 'Spill hendelser',
	},
	'Click to upload image': {
		no: 'Klikk for å lastet opp bilde',
	},
	'Recently used icons': {
		no: 'Sist brukte ikoner',
	},
	'upload...': {
		no: 'Last opp...',
	},
	'Glyphicon icons': {
		no: 'Glyphicon ikoner',
	},
	'Material icons': {
		no: 'Material ikoner',
	},
	'Logo area is 180px - 40 px': {
		no: 'Logo område er 180px - 40px',
	},
	'Server agent': {
		no: 'Server agent',
	},
	'No View': {
		no: 'Ingen visning',
	},
	'open': {
		no: 'Åpen',
	},
	'closed': {
		no: 'Lukket',
	},
	'servicemodel': {
		no: 'Tjenestemodell',
	},
	'Click to redirect to service {0}': {
		no: 'Klikk for å gå til tjeneste {0}',
	},
	'year': {
		no: 'År',
	},
	'years': {
		no: 'År',
	},
	'months': {
		no: 'Måneder',
	},
	'second': {
		no: 'Sekund',
	},
	'Default value': {
		no: 'Standard verdi',
	},
	'NO VALUE': {
		no: 'Ingen verdi',
	},
	'Configuration name': {
		no: 'Konfigurasjonsnavn',
	},
	'Agent account': {
		no: 'Agent konto',
	},
	'Asset account': {
		no: 'Ressurskonto',
	},
	'Type in reason for resetting healthindex': {
		no: 'Skriv inn årsak for tilbakestilling av helseindeks',
	},
	'd': {
		no: 'D',
	},
	'h': {
		no: 't',
	},
	'm': {
		no: 'm',
	},
	's': {
		no: 's',
	},
	'{0} - {1} of {2} items': {
		no: '{0} - {1} av {2} elementer',
	},
	'page': {
		no: 'Side',
	},
	'of {0}': {
		no: 'av {0}',
	},
	'items per page': {
		no: 'Elementer per side',
	},
	'Go to the first page': {
		no: 'Gå til første side',
	},
	'Go to the previous page': {
		no: 'Gå til forrige side',
	},
	'Go to the next page': {
		no: 'Gå til neste side',
	},
	'Go to the last page': {
		no: 'Gå til siste side',
	},
	'refresh': {
		no: 'Oppdatere',
	},
	'columns': {
		no: 'Kolonner',
	},
	'Sort descending': {
		no: 'Sorter synkende',
	},
	'notifications': {
		no: 'Varsler',
	},
	'script': {
		no: 'Skript',
		en: 'Script',
	},
	'include': {
		no: 'Inkluder',
	},
	'left': {
		no: 'Venstre',
	},
	'center': {
		no: 'Senter',
	},
	'right': {
		no: 'Høyre',
	},
	'sorting': {
		no: 'Sortering',
	},
	'qualifier': {
		no: 'Tjenestepunkt',
		en: 'Servicequalifier',
	},
	'identifier': {
		no: 'Identifikator',
	},
	'target-type': {
		no: 'Måltype',
		en: 'Target type',
	},
	'monitoring': {
		no: 'Monitorering',
	},
	'automation': {
		no: 'Automatisering',
	},
	'asset_group': {
		no: 'Ressursgruppe',
		en: 'Assetgroup',
	},
	'tags': {
		no: 'Etiketter',
		en: 'Tags',
	},
	'legacy': {
		no: 'Legacy',
	},
	'sla': {
		no: 'SLA',
		en: 'SLA',
	},
	'layout': {
		no: 'Oppsett',
	},
	'recipients': {
		no: 'Mottaker',
	},
	'reports': {
		no: 'Rapporter',
	},
	'legend': {
		no: 'Diagramforklaring',
		en: 'Legend',
	},
	'timezone': {
		no: 'Tidssone',
		en: 'Time Zone',
	},
	'historic': {
		no: 'Historikk',
	},
	'widgets': {
		no: 'Widgeter',
	},
	'current': {
		no: 'Nåværende',
		en: 'Current',
	},
	'deselect_all': {
		no: 'Fjern alle',
		en: 'Deselect all',
	},
	'select_all': {
		no: 'Velg alle',
		en: 'Select all',
	},
	'report': {
		no: 'Rapport',
	},
	'document': {
		no: 'Dokument',
	},
	'Breached': {
		no: 'Brudd',
	},
	'Warning': {
		no: 'Advarsel',
	},
	'Compliant': {
		no: 'Samsvar',
	},
	'Info': {
		no: 'Info',
	},
	'Group': {
		no: 'Gruppe',
	},
	'Key': {
		no: 'Nøkkel',
	},
	'Field': {
		no: 'Felt',
	},
	'OK': {
		no: 'OK',
	},
	'Critical': {
		no: 'Kritisk',
	},
	'Major': {
		no: 'Alvorlig',
	},
	'Minor': {
		no: 'Varsel',
	},
	'Category': {
		no: 'Kategori',
	},
	'Persist': {
		no: 'Vedvare',
	},
	'Apply': {
		no: 'Bruk',
	},

	'Alert': {
		no: 'Advarsel',
	},
	'Clear': {
		no: 'Tøm',
	},
	'Error': {
		no: 'Feil',
	},
	'Week': {
		no: 'Uke',
	},
	'Maintenance': {
		no: 'Vedlikehold',
	},
	'Yes': {
		no: 'Ja',
	},
	'No': {
		no: 'Nei',
	},
	'Add': {
		no: 'Legg til',
	},
	'Target': {
		no: 'Mål',
	},
	'Monday': {
		no: 'Mandag',
	},
	'Tuesday': {
		no: 'Tirsdag',
	},
	'Wednesday': {
		no: 'Onsdag',
	},
	'Thursday': {
		no: 'Torsdag',
	},
	'Friday': {
		no: 'Fredag',
	},
	'Saturday': {
		no: 'Lørdag',
	},
	'Sunday': {
		no: 'Søndag',
	},
	'Businessweek': {
		no: 'Arbeidsuke',
	},
	'Weekend': {
		no: 'Helg',
	},
	'Event': {
		no: 'Hendelse',
	},
	'Unacknowledge': {
		no: 'Ubekreft',
	},
	'Entries': {
		no: 'Oppføringer',
	},
	'State': {
		no: 'Tilstand',
	},
	'Service': {
		no: 'Tjeneste',
	},
	'Classname': {
		no: 'Klassenavn',
	},
	'Responsible': {
		no: 'Ansvarlig',
	},
	'Up': {
		no: 'Oppe',
	},
	'Down': {
		no: 'Nede',
	},
	'Vendor': {
		no: 'Leverandør',
	},
	'Version': {
		no: 'Versjon',
	},
	'Action': {
		no: 'Handling',
	},
	'Unavailable': {
		no: 'Ikke tilgjengelig',
	},
	'Assetgroups': {
		no: 'Ressursgrupper',
	},
	'Status': {
		no: 'Status',
	},
	'Account/subaccount': {
		no: 'Konto og underkonto',
	},
	'Subaccount': {
		no: 'Underkontoer',
	},
	'All': {
		no: 'Alle',
	},
	'Filtered': {
		no: 'Filtrert',
	},
	'Created': {
		no: 'Opprettet',
	},
	'Test': {
		no: 'Test',
	},
	'Pattern': {
		no: 'Mønster',
	},
	'Separator': {
		no: 'Skilletegn',
	},
	'True': {
		no: 'Sann',
	},
	'False': {
		no: 'Usann',
	},
	'Caption': {
		no: 'Caption',
	},
	'Process': {
		no: 'Prosess',
	},
	'Missing': {
		no: 'Mangler',
	},
	'Original': {
		no: 'Opprinnelig',
	},
	'Excluded': {
		no: 'Untatt',
	},
	'Running': {
		no: 'Kjører',
	},
	'Stopped': {
		no: 'Stoppet',
	},
	'Actions': {
		no: 'Handlinger',
	},
	'Save': {
		no: 'Lagre',
	},
	'AUTO': {
		no: 'AUTO',
	},
	'Memory': {
		no: 'Minne',
	},
	'Disk': {
		no: 'Disk',
	},
	'Used': {
		no: 'Brukt',
	},
	'Total': {
		no: 'Total',
	},
	'Title': {
		no: 'Tittel',
	},
	'Gauge': {
		no: 'Måler',
	},
	'Filtering': {
		no: 'Filtrering',
	},
	'Reset': {
		no: 'Tilbakestill',
	},
	'Selection': {
		no: 'Seleksjon',
	},
	'Multigraph': {
		no: 'Multigraf',
	},
	'Selected': {
		no: 'Valgt',
	},

	'Card': {
		no: 'Kort',
	},
	'CVID': {
		no: 'CVID',
	},
	'Password': {
		no: 'Passord',
	},
	'Username': {
		no: 'Brukernavn',
	},
	'Today': {
		no: 'I dag',
	},
	'Month': {
		no: 'Måned',
	},
	'Day': {
		no: 'Dag',
	},
	'List': {
		no: 'Liste',
	},
	'Healthindex': {
		no: 'Helseindeks',
	},
	'Module': {
		no: 'Modul',
	},
	'Read': {
		no: 'Les',
	},
	'Write': {
		no: 'Skriv',
	},
	'Details': {
		no: 'Detaljer',
	},
	'Channels': {
		no: 'Kanal',
	},
	'Notification': {
		no: 'Varsel',
	},
	'Import': {
		no: 'Importer ',
	},
	'Export': {
		no: 'Eksporter',
	},
	'Email': {
		no: 'Epost',
	},
	'Role': {
		no: 'Rolle',
	},

	'Unit': {
		no: 'Enhet',
	},
	'Conversion': {
		no: 'Konvertering',
	},
	'Color': {
		no: 'Farge',
	},
	'Informational': {
		no: 'Informasjon',
	},
	'Failed': {
		no: 'Feilet',
	},
	'Image': {
		no: 'Bilde',
	},
	'Back': {
		no: 'Tilbake',
	},
	'Text': {
		no: 'Tekst',
	},

	'Shared': {
		no: 'Delt',
	},
	'Public': {
		no: 'Åpen',
	},
	'Private': {
		no: 'Privat',
	},
	'Aggregated': {
		no: 'Aggregert',
	},
	'Edit': {
		no: 'Endre',
	},
	'File': {
		no: 'Fil',
	},
	'Tag': {
		no: 'Etikett',
	},
	'Paste': {
		no: 'Lim inn',
	},
	'Servicelink': {
		no: 'Tjenestelink',
	},
	'Copy': {
		no: 'Kopier',
	},
	'Share': {
		no: 'Del',
	},
	'Convert': {
		no: 'Konverter',
	},
	'Equal': {
		no: 'Lik',
	},
	'Min': {
		no: 'Min',
	},
	'Max': {
		no: 'Maks',
	},
	'Percentile': {
		no: 'Persentil',
	},
	'Days': {
		no: 'Dager',
	},
	'And': {
		no: 'Og',
	},
	'Or': {
		no: 'Eller',
	},
	'Not': {
		no: 'Ikke',
	},
	'Finish': {
		no: 'Fullført',
	},
	'Icons': {
		no: 'ikoner',
	},
	'Show': {
		no: 'Vis',
	},
	'Hide': {
		no: 'Skjul',
	},
	'Download': {
		no: 'Last ned',
	},
	'Preview': {
		no: 'Forhåndsvisning',
	},
	'Recalculate': {
		no: 'Rekalkuler',
	},
	'Recalculation': {
		no: 'Rekalkulering',
	},
	'Unknown': {
		no: 'Ukjent',
	},
	'Minute': {
		no: 'Minutt',
	},

	'Allocated': {
		no: 'Allokert',
	},
	'Rows': {
		no: 'Størrelse',
	},
	'Server': {
		no: 'Server',
	},
	'Topic': {
		no: 'Emne',
	},
	'Data': {
		no: 'Data',
	},
	'In': {
		no: 'Inn',
	},
	'Out': {
		no: 'Ut',
	},
	'Operation': {
		no: 'Handling',
	},
	'Installed': {
		no: 'Installert',
	},
	'Logout': {
		no: 'Logg ut',
	},
	'Dirty confirmation': {
		en: 'You have unsaved content. You will lose the changes if you click close. Click cancel and save the changes if you want to keep the changes.',
		no: 'Du har ulagret innhold, du vil miste endringen hvis du klikker Lukk. Trykk avbryt og lagre endringen hvis du vil beholde endringene.',
	},
	'cost model': {
		no: 'Kostmodell',
	},
};
